import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vuelidate from 'vuelidate'
import underscore from 'vue-underscore'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/sass/index.scss'
import VueCookies from 'vue-cookies'
import i18n from './i18n'
import VueCurrencyInput from 'vue-currency-input'
import moment from 'moment-timezone'
import VueSmoothScroll from 'vue2-smooth-scroll'
import VueMeta from 'vue-meta'
import VueLazyLoad from 'vue-lazyload'
import VModal from 'vue-js-modal'

moment.tz.setDefault('Asia/Tokyo')
Vue.prototype.moment = moment

Vue.use(VueCurrencyInput)
Vue.use(VueCookies)
Vue.use(Vuelidate)
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(underscore)
Vue.use(VueSmoothScroll, {
  duration: 1000,
  updateHistory: false
})
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})
Vue.use(VueLazyLoad)
Vue.use(VModal)

Vue.config.productionTip = false

let locale = window.location.pathname.replace(/^\/([^]+).*/i, '$1')
locale = locale.split('/')
moment.locale(locale)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
